<template>
    <div class="preview-relacion-container">
        <div v-if="relacion.show_img && tratamiento?.imagen">
            <v-img
                :src="assetAWS(tratamiento.imagen)"
                aspect-ratio="1.7"
                width="100px"
                contain
            />
        </div>

        <div class="preview-contenido">
            
            <h4 :class="{
                'resaltado': relacion.nombre_resaltado,
                'title-center': !tratamiento?.descripcion && !showSeparador
            }">
                <v-img
                    v-if="relacion.show_nombre_imagen && tratamiento?.nombre_imagen"
                    :src="assetAWS(tratamiento.nombre_imagen)"
                    width="120px"
                    contain
                />
                <span v-else>{{ tratamiento?.nombre }}</span>
                    
            </h4>
            
            <hr class="hr" 
                v-if="showSeparador" 
            />
            
            <h6>
                {{ tratamiento?.descripcion }}
            </h6>

        </div>
        
        
        <article v-if="showIconModal && !showPrecio" class="ct-accion-center" >
            <v-btn 
                v-if="showIconModal"
                icon
                class="icon-center"
                :class="{
                    'icon-top': showImgNombre,
                }"
                >
                <v-icon color="secondary">mdi-information-outline</v-icon>
            </v-btn>
        </article>


        <article v-if="showPrecio" class="ct-accion">
            <v-btn
                v-if="showIconModal" 
                icon
                :class="{
                    'icon-top': showImgNombre,
                }"
                >
                <v-icon color="secondary">mdi-information-outline</v-icon>
            </v-btn>

            <h6>
                <b v-if="relacion.precio > 0">+ S/ {{ relacion.precio }}</b>
                <b v-else>Gratis</b>
            </h6>
        </article>
        
        

    </div>
</template>

<script>

    export default {
        name: "PreviewRelacion",
        props: {
            relacion: {
                type: Object,
                required: true
            },
            tratamiento: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        computed: {
            showIconModal() {
                return this.relacion.show_icon_info && this.relacion.idmodal !== null;
            },
            showPrecio() {
                return this.relacion.show_precio;
            },
            showSeparador() {
                return !this.relacion.show_img;
            },
            showImgNombre() {
                return this.relacion.show_nombre_imagen && this.tratamiento?.nombre_imagen;
            }
            
        },
    }
</script>

<style scoped>
    .preview-relacion-container{
        border: 1px solid #ccc;
        border-radius: 8px;
        padding: 20px;
        background-color: rgba(255, 255, 255, 0.9);
        color: #333;
        display: flex;
        flex-direction: row;
        width: 700px;
        align-items: center;
    }

    .preview-relacion-container h4 {
        font-size: 1.5rem;
        padding: .5rem;
    }

    .preview-relacion-container h6 {
        font-size: 1rem;
        padding: .5rem;
        /* color: #555; */
        font-weight: normal;
    }

    .preview-contenido{
        flex:1;
        display: block;
        position: relative;;
    }

    .prev-text{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .5rem;
    }

    .resaltado{
        font-weight: bold;
        font-size: 1.1rem;
        color: #1976d2;
        font-style: italic;
    }

    .title-center{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }



    .ct-accion-center{
        position: relative;
        height: 100%;
        width: 5rem;;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .ct-accion{
        position: relative;
        height: 100%;
        width: 5rem;;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .ct-accion button{
        position: absolute;
        top: .15rem;
    }

    .ct-accion h6{
        position: absolute;
        bottom: 0;
        padding: 0;

    }

    .icon-center{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    .icon-top{
        position: absolute;
        top: 0;
    }
    
    .hr{
        margin: 0.5rem 0;
    }


</style>